<template>
	<NuxtLayout>
		<div class="bg-gray-50">
			<Html>
				<Head>
					<Title>
						Subscribe or Buy Your Next Car | carbar Australia
					</Title>
					<Meta
						name="description"
						content="Buy, finance or subscribe to your next car online. Sell your car without haggling, get an instant valuation."
					/>
				</Head>
			</Html>

			<DefaultSection>
				<div class="mt-20 flex flex-col items-center">
					<h1>{{ error.statusCode ?? '404' }}</h1>
					<div class="text-xl text-gray-600">
						{{
							error.statusMessage ??
							"Oops. We can't seem to find the page you are looking for."
						}}
					</div>
					<div class="mb-40 mt-8">
						<CarbarButton
							background-color="bg-orange-400"
							font-weight="font-medium"
							text-color="text-white"
							rounded="rounded"
							@click="handleError()"
						>
							{{ buttonLabel }}
						</CarbarButton>
					</div>
				</div>
			</DefaultSection>
		</div>
	</NuxtLayout>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import DefaultSection from '@/components/sections/DefaultSection.vue'

const props = defineProps({
	error: Object,
})

const handleError = () => {
	const redirectTo = props.error?.data?.redirectTo || '/'
	clearError({ redirect: redirectTo })
}

const buttonLabel = computed(
	() => props.error?.data?.buttonLabel || 'Back to Home'
)
</script>
